import { TFunction } from "i18next";

import { MAX_DOCUMENT_SIZE_MB, MAX_IMAGE_SIZE_MB, SUPPORTED_DOCUMENT_TYPES, SUPPORTED_IMAGE_TYPES } from "../../pages/DashBoard/partials/Feed/constants";

export const validatePostAttachments = (file: File, isImage: boolean, t: TFunction) => {
    const maxSize = isImage ? MAX_IMAGE_SIZE_MB : MAX_DOCUMENT_SIZE_MB;
    const supportedTypes = isImage ? SUPPORTED_IMAGE_TYPES : SUPPORTED_DOCUMENT_TYPES;
    
    if (file.size > maxSize * 1024 * 1024) {
      return t(isImage ? 'form_validation_messages.image_size_exceeded' : 'form_validation_messages.document_size_exceeded', { size: maxSize });
    }
    
    if (!supportedTypes.includes(file.type)) {
      return t(isImage ? 'form_validation_messages.unsupported_image_type' : 'form_validation_messages.unsupported_document_type');
    }
    
    return null;
  };